// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

const useIsProductRestricted = (product: ProductModel | undefined) => {
    const isAdmin = useAppSelector(state => state?.context?.session?.userRoles?.includes("admin"));
    if (isAdmin) {
        return false;
    }
    if (!product) {
        return false;
    }
    // eslint-disable-next-line no-unsafe-optional-chaining
    if ("isOnRestrictedBuyingList" in product?.properties) {
        return product.properties.isOnRestrictedBuyingList === "false";
    }

    return false;
};

export default useIsProductRestricted;
